var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBrandWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9776 0.599609H6.6051C6.04008 0.599609 5.58203 1.06739 5.58203 1.64442V6.29961L15.0704 9.14961L24.0006 6.29961V1.64442C24.0006 1.06739 23.5426 0.599609 22.9776 0.599609Z",
    fill: "#41A5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 6.2998H5.58203V11.9998L15.0704 13.7098L24.0006 11.9998V6.2998Z",
    fill: "#2B7CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58203 12V17.7L14.5123 18.84L24.0006 17.7V12H5.58203Z",
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6051 23.4002H22.9776C23.5426 23.4002 24.0006 22.9324 24.0006 22.3554V17.7002H5.58203V22.3554C5.58203 22.9324 6.04008 23.4002 6.6051 23.4002Z",
    fill: "#103F91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3729 5.16016H5.58203V19.4102H12.3729C12.9372 19.4083 13.3941 18.9416 13.396 18.3654V6.20497C13.3941 5.62872 12.9372 5.16203 12.3729 5.16016Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8148 5.73047H5.58203V19.9805H11.8148C12.379 19.9786 12.836 19.5119 12.8378 18.9357V6.77528C12.836 6.19903 12.379 5.73234 11.8148 5.73047Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8148 5.73047H5.58203V18.8405H11.8148C12.379 18.8386 12.836 18.3719 12.8378 17.7957V6.77528C12.836 6.19903 12.379 5.73234 11.8148 5.73047Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2566 5.73047H5.58203V18.8405H11.2566C11.8209 18.8386 12.2779 18.3719 12.2797 17.7957V6.77528C12.2779 6.19903 11.8209 5.73234 11.2566 5.73047Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02307 5.73047H11.256C11.821 5.73047 12.2791 6.19825 12.2791 6.77528V17.2257C12.2791 17.8027 11.821 18.2705 11.256 18.2705H1.02307C0.458044 18.2705 0 17.8027 0 17.2257V6.77528C0 6.19825 0.458044 5.73047 1.02307 5.73047Z",
    fill: "url(#paint0_linear_6643_23254)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19827 13.743C4.21836 13.9043 4.23175 14.0445 4.23789 14.1648H4.26133C4.27026 14.0508 4.28886 13.9134 4.31714 13.7527C4.34542 13.5919 4.37091 13.4561 4.39361 13.3451L5.4697 8.60384H6.86115L7.97743 13.2739C8.04228 13.5642 8.08871 13.8586 8.11641 14.1551H8.13483C8.15563 13.8678 8.19442 13.5823 8.25092 13.3001L9.14115 8.60156H10.4076L8.84366 15.396H7.36403L6.30357 10.8964C6.27287 10.767 6.23771 10.5977 6.1992 10.3896C6.16068 10.1816 6.13669 10.0294 6.1272 9.93364H6.10877C6.0965 10.0442 6.07249 10.2084 6.03677 10.4261C6.00105 10.6439 5.9724 10.805 5.95081 10.9095L4.95397 15.3948H3.44922L1.87695 8.60383H3.16625L4.13574 13.3548C4.15752 13.4523 4.17817 13.5822 4.19827 13.743Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6643_23254",
    x1: 2.13312,
    y1: 4.91408,
    x2: 10.4013,
    y2: 18.9363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrandWord);
export default __webpack_public_path__ + "static/media/logo-brand-word.1e0fc0ae76f1ae670e4c241ef9befada.svg";
export { ForwardRef as ReactComponent };